//@flow
export const entitiesRankingActionTypes = {
  LOAD_ENTITIES_RANKING: "LOAD_ENTITIES_RANKING"
};

export type EntitiesRankingActionType = $Keys<typeof entitiesRankingActionTypes>;
